import React, { useContext,useEffect } from 'react';

import Brand from './Brand';
import SimpleContext from './../context/SimpleContext';


const Brands = () => {

    const context = useContext(SimpleContext)
    //فراخانی وب سرویس برند ها
    useEffect(()=>{
        context.getBrands()
    },[])
    return ( 
        <div className="brandsdiv">
            {
                context.getBrandsList!==undefined&&context.getBrandsList!==null&&
                context.getBrandsList.length>0?
                context.getBrandsList.map(brand => 
                    <div className="brnd" key={brand.id}>
                        <Brand 
                        img={brand.imageUrl}
                        brandid={brand.id}
                        name={brand.brandName}
                        />
                    </div>
                        
                ):null
            }
        </div>
        );
}
    
    export default Brands;
        
